import { OloHandoffMode } from './olo_handoff_mode.js';

export function name(handoffMode: OloHandoffMode): string {
  switch (handoffMode) {
    case OloHandoffMode.Pickup:
      return 'Pickup';
    case OloHandoffMode.Curbside:
      return 'Curbside';
    case OloHandoffMode.DriveThru:
      return 'Drive-Thru';
    case OloHandoffMode.Delivery:
      return 'Delivery';
    case OloHandoffMode.Dispatch:
      return 'Dispatch (3rd Party Delivery)';
    case OloHandoffMode.DineIn:
      return 'Dine In';
  }
}
